import React, { useEffect, useState } from "react";
import ContentMediaSection from "../content-sections/content-media-section";
import ContentDetailsSection from "../content-sections/content-details-section";
import Iconify from "@/components/ui/Iconify";
import { EVENT_TYPES, sendAnalyticsEvent } from "@/utils/AnalyticsEvents";
import { useAuthContext } from "@/context/auth/useAuthContext";
import { isVideoContent } from "@/constants/routes";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import {
  getContentNavigationContextType,
  openContentDetail,
} from "@/utils/content-navigation";

const ContentViewModal =
  (
    {
      allPosts,
      closePopup,
      setAllPosts,
      allUsersForTagging,
      selectedPostInModal,
      setSelectedPostInModal,
      currentUserFollowing,
      setCurrentUserFollowing,
      popupStyle,
      isAnimating,
      completeRefresh = () => { },
      isPiP,
      setIsPiP,
      playerRef,
      handleDisablePIP,
      handleEnablePIP,
      openVideoInPlay = true,
    }
  ) => {
    const { user } = useAuthContext();
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [isEventSent, setIsEventSent] = useState(false);
    const shouldOpenInPlay = openVideoInPlay && isVideoContent(selectedPostInModal);

    useEffect(() => {
      if (user?.userId !== selectedPostInModal?.userId && selectedPostInModal?.userId && !isEventSent) {
        sendAnalyticsEvent(EVENT_TYPES.views, selectedPostInModal?.userId).then(() => {
          setIsEventSent(true);
        });
      }
    }, [selectedPostInModal]);

    useEffect(() => {
      if (!shouldOpenInPlay) return;

      const sourceQuery = searchParams?.get("q") || searchParams?.get("search") || "";
      const sourcePath = `${pathname || ""}${
        searchParams?.toString() ? `?${searchParams.toString()}` : ""
      }`;
      const contextType = sourceQuery
        ? "search"
        : getContentNavigationContextType(pathname);
      const placeId =
        selectedPostInModal?.locationTag ||
        selectedPostInModal?.place?.id ||
        selectedPostInModal?.placeUniqueNumber ||
        "";

      closePopup?.();
      openContentDetail({
        router,
        content: selectedPostInModal,
        feed: allPosts,
        sourcePath,
        query: sourceQuery,
        contextType,
        placeId,
        userId:
          contextType === "profile"
            ? selectedPostInModal?.userId || selectedPostInModal?.user?.id || ""
            : "",
        categoryId: selectedPostInModal?.categoryId || "",
        category: selectedPostInModal?.category?.name || "",
        sourceParams: {
          search: sourceQuery,
          placeId,
          categoryId: selectedPostInModal?.categoryId || "",
          category: selectedPostInModal?.category?.name || "",
        },
      });
    }, [
      allPosts,
      closePopup,
      pathname,
      router,
      searchParams,
      selectedPostInModal,
      shouldOpenInPlay,
    ]);

    if (shouldOpenInPlay) return null;

    return (
      selectedPostInModal && (
        <div style={{ width: isPiP ? "0px" : "100%" }}>
          <div
            className={`fixed inset-0 h-dvh w-screen overflow-hidden flex max-md:items-start items-center justify-center transition-opacity duration-150 z-[140]
    ${selectedPostInModal
                ? "bg-black/58"
                : "pointer-events-none bg-transparent"
              }
  `}
            onClick={closePopup}
          >
            <button
              type="button"
              onClick={closePopup}
              aria-label="닫기"
              title="닫기"
              className={`hidden md:block fixed top-5 right-5 bg-black z-[150] p-2 rounded-full bg-opacity-30 backdrop-blur-lg ${isPiP ? "hidden pointer-events-none" : "block"}`}
            >
              <Iconify
                icon={"bytesize:close"}
                className={`!text-white !w-4 !h-4 ${isPiP ? "hidden pointer-events-none" : "block"}`}
              />
            </button>
            <div
              className={`h-full w-fit max-md:h-[calc(100%-52px)] md:h-[87.9vh] md:max-w-3xl lg:max-w-7xl flex bg-[#050505] overflow-hidden md:rounded-[24px] shadow-[0_24px_70px_rgba(0,0,0,0.26),0_8px_24px_rgba(0,0,0,0.14)] transition-opacity duration-150 md:transition-all
      ${selectedPostInModal
                  ? "md:animate-modal-in"
                  : "md:animate-modal-out pointer-events-none"
                }
    `}
              onClick={(e) => e.stopPropagation()}
              key={selectedPostInModal?.id || "no-post"}
            >
              <ContentMediaSection
                className={"hidden md:block h-full w-full min-w-[10rem]"}
                selectedPostInModal={selectedPostInModal}
                isPiP={isPiP}
                setIsPiP={setIsPiP}
                playerRef={playerRef}
                handleDisablePIP={handleDisablePIP}
                handleEnablePIP={handleEnablePIP}
              />
              <ContentDetailsSection
                allPosts={allPosts}
                closePopup={closePopup}
                setAllPosts={setAllPosts}
                allUsersForTagging={allUsersForTagging}
                selectedPostInModal={selectedPostInModal}
                setSelectedPostInModal={setSelectedPostInModal}
                currentUserFollowing={currentUserFollowing}
                setCurrentUserFollowing={setCurrentUserFollowing}
                completeRefresh={completeRefresh}
                isPiP={isPiP}
                setIsPiP={setIsPiP}
                playerRef={playerRef}
                handleDisablePIP={handleDisablePIP}
                handleEnablePIP={handleEnablePIP}
              />
            </div>
          </div>
        </div>
      )
    );
  }

export default ContentViewModal;
